import { types, type Instance } from 'mobx-state-tree';
import { STATUS_CERTIFIED } from 'src/constants/roleRequirementStatus';
import RoleReqAnswer from './RoleReqAnswer';
import { ANSWER_TYPE } from 'src/constants/roleRequirementsTypes';
import { Verification } from './VerificationStore/Verification';

export const STATUS_TO_SCORE_MAPPING = {
  STATUS_CUSTOM: -1,
  STATUS_MATCH: 1,
  STATUS_NO_MATCH: 0,
  STATUS_CERTIFIED: Infinity,
};

const RoleRequirement = types
  .model('RoleRequirement', {
    questionId: types.maybeNull(types.string),
    globalId: types.maybeNull(types.string),
    question: types.string,
    rrAnswers: types.array(RoleReqAnswer),
    answerType: types.maybeNull(types.string),
    score: types.maybeNull(types.number),
    status: types.string,
    verifications: types.array(Verification),
  })
  .views((self) => ({
    get answer() {
      return self.rrAnswers.map((rrAnswers) => rrAnswers.text).join(' ');
    },
    get globalIdOrId() {
      return self.globalId ?? (self.questionId as string);
    },
  }))
  .views((self) => ({
    get showVerifiedTagInAnswers() {
      return (
        self.status !== STATUS_CERTIFIED &&
        self.answerType === ANSWER_TYPE.MULTISELECT &&
        self.rrAnswers.some((rr) => rr.isVerified)
      );
    },
  }));

export interface IRoleRequirement extends Instance<typeof RoleRequirement> {}

export default RoleRequirement;
